import { Color } from './colors'

interface IColorSchemes {
  [key: string]: {
    [key: string]: {
      [key: string]: Color
    }
  }
}

export const COLOR_SCHEMES: IColorSchemes = {
  'Light/Dark': {
    Light: {
      textColor: Color.Slate,
      backgroundColor: Color.White,
    },
    Dark: {
      textColor: Color.White,
      backgroundColor: Color.Slate,
    },
  },
}
